import React, { createContext, useState } from 'react'
import { CommsPanelCtx } from '../contexts';
import { createId } from '../common/utils';

const CommsPanelsProvider = ( { children } ) => {
    const [ panels, setPanels ] = useState( [] );

    const toggleMinimized = ( panelId ) => {
        setPanels( ( prevPanels ) =>
            prevPanels.map( ( panel ) =>
                panel.id === panelId
                    ? { ...panel, minimized: !panel.minimized } // Toggle the minimized state
                    : panel
            )
        );
    };

    const addPanel = ( panelData ) => {
        const newPanel = { ...panelData, id: createId( 'panel' ) };
        console.log( 'newPanel: ', newPanel );
        setPanels( prev => [ ...prev, newPanel ] );
    };

    const closePanel = ( panelId ) => {
        setPanels( prev => prev.filter( panel => panel.id !== panelId ) );
    };

    return (
        <CommsPanelCtx.Provider value={ { panels, addPanel, closePanel, toggleMinimized } }>
            {children}
        </CommsPanelCtx.Provider>
    );
};

export default CommsPanelsProvider;